// Wording for the "you were tagged" email. Pure string building, no sending,
// so the copy is testable on its own.
//
// This is an internal note to a teammate, not a client email, so it stays
// short and skips the branded banner. It quotes the note so the reader can
// judge from their inbox whether it needs them right now.

const BRAND_LINK = "#218FDA";
const SLATE = "#334155";
const MAX_QUOTE = 600;

const escapeHtml = (s) =>
  String(s ?? "")
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;");

const firstNameOf = (name) => String(name ?? "").trim().split(/\s+/)[0] || "";

// Long chat messages and week-old call notes both land here. Quote enough to
// recognise the conversation, not the whole thing.
const trimQuote = (s) => {
  const t = String(s ?? "").trim();
  return t.length > MAX_QUOTE ? `${t.slice(0, MAX_QUOTE).trimEnd()}...` : t;
};

export function buildMentionEmail({ senderName, toName, where, text }) {
  const from = String(senderName ?? "").trim() || "Someone";
  const first = firstNameOf(toName);
  const place = String(where ?? "").trim() || "a note";
  const quote = trimQuote(text);

  const subject = `${from} mentioned you in ${place}`;
  const greeting = first ? `Hi ${first},` : "Hi,";

  const body = [
    greeting,
    "",
    `${from} tagged you in ${place}.`,
    "",
    quote,
    "",
    "Open the CRM to reply or pick it up from there.",
  ].join("\n");

  const html = [
    `<div style="font-family:Arial,Helvetica,sans-serif;font-size:15px;color:${SLATE};line-height:1.6;">`,
    `<p style="margin:0 0 14px;">${escapeHtml(greeting)}</p>`,
    `<p style="margin:0 0 14px;">${escapeHtml(from)} tagged you in ${escapeHtml(place)}.</p>`,
    `<blockquote style="margin:0 0 16px;padding:10px 14px;border-left:3px solid ${BRAND_LINK};background:#F1F5F9;color:${SLATE};white-space:pre-wrap;">${escapeHtml(quote)}</blockquote>`,
    `<p style="margin:0;">Open the CRM to reply or pick it up from there.</p>`,
    `</div>`,
  ].join("");

  return { subject, text: body, html };
}
